import { EmeraldCheckbox } from "@emerald-react/checkbox";
import { EmeraldIconButton } from "@emerald-react/icon-button";
import type { SurveyNotifier } from "@survey-types/survey.core.types";

interface NotificationItemProps {
  notifier: SurveyNotifier;
  onUpdate: (notifierId: string, isShortlistEnabled: boolean) => Promise<void>;
  onRemove: (email: string) => Promise<void>;
}

const NotificationItem = ({
  notifier,
  onUpdate,
  onRemove,
}: NotificationItemProps) => {
  const handleCheckboxChange = async (checked: boolean) => {
    await onUpdate(notifier.notificationId, checked);
  };

  const handleRemove = async () => {
    await onRemove(notifier.email);
  };

  return (
    <div className="flex items-center justify-between py-1 px-2 rounded">
      <div className="flex items-center gap-2">
        <EmeraldCheckbox
          id={`email-${notifier.notificationId}`}
          checked={notifier.isShortlistEnabled}
          onChange={handleCheckboxChange}
          label=""
        />
        <span className="text-sm">{notifier.email}</span>
      </div>
      <EmeraldIconButton
        icon="close"
        type="Icon"
        onClick={handleRemove}
        size="Small"
      />
    </div>
  );
};

export default NotificationItem;
